//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'detail_service_title',
  props: {
    serviceTitleList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    onclickTitles: function onclickTitles() {
      this.$emit('toggleServiceTitle');
    }
  }
};